import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {AuthService} from './auth.service';
import {Location} from '@angular/common';
import {RouterUtilityService} from './router.utility.service';
import {BehaviorSubject, Subject} from 'rxjs';

@Injectable()
export class RouteService {
    navigatedFromUrlSegment = 'home';
    urlQuerySting = new Subject<any>();
    toggleSideNavInMobileMode = new BehaviorSubject<any>(false);
    toggleSearchInMobileMode = new BehaviorSubject<any>(false);

    constructor(private router: Router,
                private authService: AuthService,
                private routerUtilityService: RouterUtilityService,
                private location: Location) {
    }

    lang = 'prs';

    setProperRoute() {
        this.lang = localStorage.getItem('lang') ? localStorage.getItem('lang') : this.lang;
        const path = this.location.prepareExternalUrl(this.location.path());
        const pathArray = path.split('/');
        if (this.routerUtilityService.getUrlParameterByName('singleUseToken', path)) {
            this.router.navigate([path.split('?')[0]]);
        }

        if (!this.authService.isUserAuthenticated) {
            this.navigateToLoginForm();
        }

        if (pathArray[1] === '' || pathArray[1].indexOf('?toAuth=true') > -1) {
            this.router.navigateByUrl(`${this.lang}/home`);
        }
    }

    navigateToLoginForm() {
        this.router.navigateByUrl('login');
    }

}
